import styled from "styled-components";

const FooterWrapper = styled.footer`
  background-color: #120D09;
  color: #a3998f;
  font-family: "Mulish", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  padding: 64px 0 0;
  position: relative;
  overflow: visible;

  @media (max-width: 768px) {
    padding: 40px 0 76px;
  }

  .footer-container {
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
    padding: 0 24px;
    box-sizing: border-box;

    @media (max-width: 1200px) {
      padding: 0 20px;
    }

    @media (max-width: 768px) {
      padding: 0 16px;
    }

    @media (max-width: 380px) {
      padding: 0 12px;
    }
  }

  .footer-row {
    display: grid;
    grid-template-columns: 1.35fr 0.9fr 1.05fr 1.3fr;
    gap: 48px;
    padding-bottom: 50px;
    align-items: start;

    @media (max-width: 1100px) {
      grid-template-columns: 1fr 1fr;
      gap: 40px 30px;
    }

    @media (max-width: 768px) {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      width: 100%;
      gap: 0;
      padding-bottom: 24px;

      .brand-col {
        order: 1;
        width: 100%;
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.08);
        margin-bottom: 24px;
      }

      .links-col {
        order: 3;
        width: 100%;
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.08);
        margin-bottom: 24px;
      }

      .visit-col {
        order: 2;
        width: 100%;
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.08);
        margin-bottom: 24px;
      }

      .treatments-col {
        display: none !important;
      }

      .mobile-google-badge {
        order: 4;
        width: 100%;
      }
    }
  }

  /* Visibility toggles */
  .desktop-only {
    display: block;
    @media (max-width: 768px) {
      display: none !important;
    }
  }

  .mobile-section-divider {
    display: none;
    @media (max-width: 768px) {
      display: block;
      width: 100%;
      height: 1px;
      background: rgba(255, 255, 255, 0.08);
      margin: 22px 0 24px;
    }
  }

  /* Brand Column */
  .brand-col {
    .footer-logo {
      display: inline-block;
      margin-bottom: 18px;

      img {
        width: 175px;
        height: auto;
        display: block;
      }
    }

    .brand-desc {
      font-size: 14px;
      line-height: 1.65;
      color: #A89F91;
      max-width: 330px;
      margin-bottom: 20px;

      @media (max-width: 768px) {
        max-width: 100%;
        margin-bottom: 0;
      }
    }

    .brand-divider {
      width: 100%;
      max-width: 330px;
      height: 1px;
      background: rgba(255, 255, 255, 0.08);
      margin-bottom: 20px;
    }

    .google-badge {
      display: flex;
      flex-direction: column;
      gap: 6px;

      .badge-stars-row {
        display: flex;
        align-items: center;
        gap: 10px;

        .google-icon {
          display: flex;
          align-items: center;
        }

        .stars {
          display: flex;
          gap: 3px;
          color: #e59f2c;
          font-size: 13px;
        }
      }

      .badge-text {
        font-size: 13.5px;
        color: #D5CEC4;
        font-weight: 500;
        letter-spacing: 0.2px;
      }
    }
  }

  /* Section Titles */
  .footer-col-title {
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    color: #D87B1C;
    margin-bottom: 20px;
    font-family: "Mulish", sans-serif;
  }

  /* Quick Links List */
  .footer-links-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;

    li {
      margin: 0;
      padding: 0;
      width: 100%;
    }

    .footer-nav-link {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #D5CEC4;
      text-decoration: none;
      font-size: 14.5px;
      font-weight: 400;
      transition: all 0.2s ease;
      width: 100%;

      @media (min-width: 769px) {
        max-width: 220px;
      }

      @media (max-width: 768px) {
        max-width: 100%;
        padding: 2px 0;
      }

      span {
        transition: transform 0.2s ease, color 0.2s ease;
      }

      .link-arrow {
        font-size: 15px;
        color: #8E8275;
        transition: transform 0.2s ease, color 0.2s ease;
      }

      &:hover {
        color: #f7eed7;

        span {
          color: #ffffff;
          transform: translateX(2px);
        }

        .link-arrow {
          color: #D87B1C;
          transform: translateX(3px);
        }
      }
    }
  }

  /* Visit Us Contact List */
  .contact-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 16px;

    .contact-item {
      display: flex;
      align-items: flex-start;
      gap: 14px;
      font-size: 14px;
      line-height: 1.55;
      color: #D5CEC4;

      .contact-icon-svg {
        color: #D87B1C;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 2px;
        flex-shrink: 0;
        width: 18px;
      }

      .contact-text {
        color: #D5CEC4;
        text-decoration: none;

        a {
          color: #D5CEC4;
          text-decoration: none;
          transition: color 0.2s ease;

          &:hover {
            color: #D87B1C;
          }
        }
      }
    }
  }

  /* Mobile Google Reviews Badge below Quick Links */
  .mobile-google-badge {
    display: none;

    @media (max-width: 768px) {
      display: flex;
      flex-direction: column;
      gap: 6px;
      margin: 4px 0 16px;

      .badge-stars-row {
        display: flex;
        align-items: center;
        gap: 10px;

        .google-icon {
          display: flex;
          align-items: center;
        }

        .stars {
          display: flex;
          gap: 3px;
          color: #e59f2c;
          font-size: 13px;
        }
      }

      .badge-text {
        font-size: 13.5px;
        color: #D5CEC4;
        font-weight: 500;
        letter-spacing: 0.2px;
      }
    }
  }

  /* Bottom Copyright Bar */
  .footer-bottom-bar {
    border-top: 1px solid rgba(255, 255, 255, 0.07);
    padding: 22px 0;
    text-align: center;

    .copyright-text {
      margin: 0;
      font-size: 13px;
      color: #7a7066;
      font-weight: 400;
      letter-spacing: 0.2px;
    }
  }

  /* Mobile Fixed Bottom Navigation Bar */
  .mobile-bottom-nav {
    display: none;

    @media (max-width: 768px) {
      display: flex;
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      height: 62px;
      background: #ffffff;
      border-top: 1px solid #ECE7DF;
      box-shadow: 0 -3px 12px rgba(0, 0, 0, 0.08);
      z-index: 9990;
      justify-content: space-around;
      align-items: center;
      padding: 0 4px;
      padding-bottom: env(safe-area-inset-bottom, 0px);
      box-sizing: border-box;

      .bottom-nav-item,
      button.bottom-nav-item,
      .btn-more {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        flex: 1;
        text-decoration: none;
        color: #4A453E;
        background: transparent !important;
        border: none !important;
        border-radius: 0 !important;
        box-shadow: none !important;
        outline: none !important;
        padding: 5px 0 !important;
        cursor: pointer;
        position: relative;
        transition: color 0.2s ease;
        -webkit-appearance: none;
        appearance: none;
        transform: none !important;

        &:hover,
        &:focus,
        &:active {
          box-shadow: none !important;
          outline: none !important;
          background: transparent !important;
          border: none !important;
          transform: none !important;
        }

        &.btn-more {
          box-shadow: none !important;
          background: transparent !important;
          border: none !important;
          border-radius: 0 !important;
          outline: none !important;
          transform: none !important;

          &:hover,
          &:focus,
          &:active {
            box-shadow: none !important;
            background: transparent !important;
            border: none !important;
            outline: none !important;
            transform: none !important;
          }
        }

        .bottom-nav-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 24px;
          margin-bottom: 2px;
        }

        .bottom-nav-label {
          font-size: 11px;
          font-weight: 600;
          color: #38332B;
          letter-spacing: 0.1px;
          line-height: 1.1;
        }

        &.active {
          .bottom-nav-label {
            font-weight: 700;
            color: #1C1917;
          }
        }

        &.book-item {
          .floating-book-btn {
            width: 48px;
            height: 48px;
            border-radius: 50%;
            background: linear-gradient(135deg, #E68B29 0%, #D87B1C 100%);
            display: flex;
            align-items: center;
            justify-content: center;
            border: 3px solid #ffffff;
            box-shadow: 0 4px 12px rgba(216, 123, 28, 0.4);
            margin-top: -24px;
            margin-bottom: 2px;
            transition: transform 0.2s ease;
          }

          &:active .floating-book-btn {
            transform: scale(0.95);
          }
        }
      }
    }
  }

  /* Floating WhatsApp and Call CTA Buttons Stack */
  .floating-actions-stack {
    position: fixed;
    bottom: 24px;
    right: 22px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    z-index: 9995;

    @media (max-width: 768px) {
      bottom: 84px;
      bottom: calc(64px + env(safe-area-inset-bottom, 0px) + 18px); /* Clear above mobile bottom nav bar */
      right: 16px;
      gap: 10px;
    }

    .floating-action-btn {
      position: static !important;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      text-decoration: none;
      transition: transform 0.25s ease, box-shadow 0.25s ease;
      cursor: pointer;

      &:hover {
        transform: scale(1.08);
      }

      &:active {
        transform: scale(0.95);
      }

      @media (max-width: 768px) {
        width: 48px;
        height: 48px;
      }
    }

    .whatsapp-action-btn,
    .whatsapp-btn {
      background-color: #25d366;
      color: #ffffff;
      box-shadow: 0 4px 16px rgba(37, 211, 102, 0.45);

      &:hover {
        box-shadow: 0 6px 22px rgba(37, 211, 102, 0.65);
        color: #ffffff;
      }

      svg {
        width: 27px;
        height: 27px;
        @media (max-width: 768px) {
          width: 25px;
          height: 25px;
        }
      }
    }

    .call-action-btn,
    .call-btn {
      display: none !important;
      background-color: #ba6721;
      color: #ffffff;
      box-shadow: 0 4px 16px rgba(186, 103, 33, 0.45);

      @media (max-width: 768px) {
        display: flex !important;
      }

      &:hover {
        box-shadow: 0 6px 22px rgba(186, 103, 33, 0.65);
        color: #ffffff;
      }

      svg {
        width: 23px;
        height: 23px;
        stroke: #ffffff;
        @media (max-width: 768px) {
          width: 21px;
          height: 21px;
        }
      }
    }
  }
`;

export default FooterWrapper;
